module.exports = __webpack_public_path__ + "static/chart-02d23015b5c7ccf85679a9731f936ffe.jpg";